import CarServicesController from './CarServicesController';
import BreakdownController from './BreakdownController';
export default

    class MaintenanceController {

    constructor(resource) {
        this._baseUrl = 'maintenance';
        this._resource = resource;
        this.carServices = new CarServicesController(resource);
        this.breakdown = new BreakdownController(resource);
    }

    getAllMaintenance({clientId = null, vehicleId = null, situation = null} = {}){
        return this._resource(`maintenance/client`, {clientId: clientId, vehicleId: vehicleId, situation: situation == 'all' ? null : situation})
                        .get()
                        .then(v =>  v, err => {throw(err);});
    }

    deleteMaintenanceById(maintenanceId){
        return this._resource(`maintenance/delete/${maintenanceId}`).delete()
                        .then(v =>  v, err => {throw(err);})
    }

    createMaintenance(maintenance){
        return this._resource(`maintenance`).save(maintenance)
            .then(v => {
                console.log(maintenance);
                if(maintenance.type == "servico"){
                    this.carServices.createCarService({
                        amount: 0,
                        car_service_type_id: maintenance.carServiceType,
                        date_service: maintenance.begin_date,
                        vehicle_id: maintenance.vehicle_id
                    });
                }else{
                    this.breakdown.createBreakdown({
                        vehicle_id: maintenance.vehicle_id,
                        status: false,
                        date_breakdown: maintenance.begin_date,
                        breakdown_type_id: maintenance.breakdownType,
                        client_id: maintenance.client_id
                    });
                }
                
                return v; 
            }, err => {throw(err);});
        
    }

    finishMaintenance(maintenanceId){
        return this._resource(`maintenance/finish/${maintenanceId}`).update()
        .then(v =>  v, err => {throw(err);})
    }

    updateMaintenance(maintenance){
        return this._resource(`maintenance/update`).update(maintenance)
        .then(v =>  v, err => {throw(err);})
    }
}